// @flow

import * as R from 'ramda';

import { HttpService } from '~/services';
import {
  getRouteNavigationParamsWithFormattedDate,
  renameKeys,
} from '~/helpers';

export const resolvers = {
  Query: {
    archivedGrowthRewardHistory: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      props: RouteNavigationInputProps,
      { cache }: ApolloCache,
    ): Promise<?SuperOrderPassiveIncomeResponse> => {
      const columnsMapping = {
        DateTimeUtc: 'date',
        OrderID: 'orderId',
        MerchantName: 'merchantName',
        PlatformName: 'platformName',
        PersonalReward: 'personalReward',
        PersonalRewardUsdAmt: 'personalRewardUsdAmt',
        GrowthReward: 'growthReward',
        GrowthRewardPct: 'growthRewardPct',
        TotalReward: 'totalReward',
      };

      const params = getRouteNavigationParamsWithFormattedDate(
        {
          date: ['DateFromUtc', 'DateToUtc'],
          orderId: 'OrderID',
          personalReward: ['PersonalRewardFrom', 'PersonalRewardTo'],
          personalRewardUsdAmt: [
            'PersonalRewardUsdAmtFrom',
            'PersonalRewardUsdAmtTo',
          ],
          growthReward: ['GrowthRewardFrom', 'GrowthRewardTo'],
          totalReward: ['TotalRewardFrom', 'TotalRewardTo'],
        },
        R.invertObj(columnsMapping),
      )(props);

      // Get self consumption list
      const {
        data: { GrowthRewardList, PageCount = 1 },
      } = await HttpService.client.get(
        '/Legacy/v3/MyWealth/Consumption/GetGrowthRewardTrxList',
        { params },
      );

      const items: GrowthRewardItem[] = R.map(
        R.pipe(
          renameKeys(columnsMapping),
          R.evolve({
            personalReward: parseFloat,
            personalRewardUsdAmt: parseFloat,
            growthReward: parseFloat,
            totalReward: parseFloat,
          }),
          R.assoc('__typename', 'GrowthRewardItemType'),
        ),
        GrowthRewardList,
      );

      const growthReward = {
        data: items,
        pages: PageCount,
        __typename: 'GrowthRewardListType',
      };

      cache.writeData({
        data: { growthReward },
        variables: props,
      });

      return growthReward;
    },
  },
};
